// A list at a glance — the bar, what is still open, finished out of total. Every figure
// is the server's summary (calculations/listSummary); nothing is counted here, so the
// board, the panel, the job screen and the index cannot disagree about one list.
import he from '../../i18n/he';

export const toneClass = (tone) => `tone-${tone}`;

// One segment per state that holds rows, in the list's own order.
export function ListBar({ summary, thin }) {
  const label = summary.states.map((s) => `${s.label} ${s.count}`).join(', ');
  return (
    <span className={`list-bar${thin ? ' thin' : ''}`} role="img" aria-label={label}>
      {summary.states.filter((s) => s.count > 0).map((s) => (
        <span key={s.id} className={toneClass(s.tone)} style={{ flexGrow: s.count }} />
      ))}
    </span>
  );
}

// The open states' counts, or "הכול טופל" once nothing is left open.
export function ListCounts({ summary }) {
  if (summary.total === 0) return <span className="list-counts" />;
  const open = summary.states.filter((s) => !s.is_finished && s.count > 0);
  return (
    <span className="list-counts">
      {open.length === 0
        ? <span className="badge green">{he.lists.allDone}</span>
        : open.map((s) => (
          <span key={s.id} className={toneClass(s.tone)}>
            <span className="dot" />{s.label} {s.count}
          </span>
        ))}
    </span>
  );
}

export const ListRatio = ({ summary }) => (
  <span className="list-ratio num"><b>{summary.finished}</b>/{summary.total}</span>
);

export const ListIcon = () => (
  <svg className="list-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
    <path d="M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01" />
  </svg>
);

// The one line under a task on the board: the whole line opens the list.
export function ListStrip({ summary, onOpen }) {
  return (
    <button type="button" className="list-strip" onClick={onOpen} aria-label={he.lists.open}>
      <ListIcon />
      <ListBar summary={summary} thin />
      <ListCounts summary={summary} />
      <ListRatio summary={summary} />
    </button>
  );
}
